import { Map, Record } from 'immutable';

export default Record({
    companyId: null,
    id: null,
    identifier: null,
    meta: Map({}),
    service: null,
    type: null,
});
